// AUTO-GENERATED — do not edit. Source: Supabase catalog.report_sales_copy raw.intent_pages
// Build mirror: business/ishvaram/data/commerce/report_sales_copy.generated.yaml

export const reportIntentPages = {
  "annual-forecast": {
    faq: [
      {
        a: "A yearly rashifal is written for a whole rashi. This is computed from your exact birth chart - your dasha, your transits, your houses - so the timing is yours, not a sign's.",
        q: "How is this different from a free yearly rashifal?",
      },
      {
        a: "The 12 months ahead from your reading, mapped to your running dasha and the live Shani and Jupiter transits.",
        q: "Which year does it cover?",
      },
    ],
    fit: "Best when you want to time the year ahead - career moves, money decisions, marriage, travel, or major commitments - to your own chart.",
    lead: "A generic yearly rashifal reads the same for millions. Your varshphal is built from your own chart - the running mahadasha and antardasha, this year's Shani and Jupiter transits over your houses, and the specific months they turn supportive or heavy.",
    slug: "annual-forecast",
    title: "Why will some months in the year ahead lift you and others test you?",
    intent: "chart_report",
    eyebrow: "Annual Forecast 2026-27",
    reportSlug: "annual-forecast",
    checkpoints: [
      "Month-by-month timing for the next 12 months, not a generic yearly blurb",
      "Your running mahadasha and antardasha and what each is ripening",
      "Shani (Saturn) and Jupiter transits over your houses, with dates",
      "The strong windows to act and the heavy windows to plan around",
    ],
    description:
      "A personal Annual Forecast (varshphal) for the year ahead - month-by-month dasha and transit timing, the windows that favour you, and the ones to plan around.",
    inputSurface: "kundali",
    offerSubhead:
      "Generate your kundali first, then get your month-by-month dasha and transit timing for the year ahead.",
    offerHeadline: "Get your Annual Forecast",
    customerProblem: "forecast",
    collectInputsLabel: "Enter details for Annual Forecast",
  },
  "baby-name-report": {
    faq: [
      {
        a: "A free list is not tied to your child's chart. This report first computes the janma nakshatra and pada, gives the exact auspicious syllables those open, and only then suggests names.",
        q: "How is this different from a free baby-name list?",
      },
      {
        a: "Date, time, and place of birth. The Moon's nakshatra and pada at birth decide the starting syllables, so the birth time should be as accurate as possible.",
        q: "What details do I need for the child?",
      },
      {
        a: "The syllable comes from the nakshatra; the name is still yours to choose. The report curates modern and classical names for each auspicious starting sound, with meaning and numerology fit alongside, so tradition and taste never have to fight each other.",
        q: "What if the suggested syllables feel old-fashioned?",
      },
      {
        a: "The namkaran principle applies to the name the child is actually called by. Many families keep the nakshatra name for ritual and home use while matching the official name's numerology separately — the report covers both paths so nothing is left to guesswork.",
        q: "Can we use this for the official name or a home name?",
      },
      {
        a: "The Moon changes pada every few hours, so a roughly known time usually still fixes the nakshatra safely. Where a birth sits near a pada boundary, the report flags it and gives the auspicious syllables on both sides instead of quietly guessing one.",
        q: "What if the birth time is uncertain?",
      },
      {
        a: "Tradition favours the naming ceremony after the first days have passed, on a day whose nakshatra agrees with the child's own. The report focuses on the name itself; for choosing the ceremony day, the muhurat tools on this site read the calendar against the child's nakshatra.",
        q: "When should the namkaran be done?",
      },
      {
        a: "Each child gets an independent reading. Even minutes between births can move the Moon to the next pada and change the auspicious syllables entirely, so twins frequently receive different starting sounds — a feature of the tradition, not an inconvenience.",
        q: "Does the report work for twins?",
      },
      {
        a: "The reading is still useful: it verifies whether the given name sits well with the nakshatra, and where it does not, tradition allows a nakshatra-correct name kept for ritual and blessing alongside the everyday one. Nothing needs to be undone.",
        q: "What if we already performed the namkaran?",
      },
      {
        a: "Every curated name carries its meaning and its numerology fit, because a beautiful sound with an unfortunate meaning — or a number that fights the birth date — defeats the purpose of choosing carefully.",
        q: "Do the suggested names come with meanings?",
      },
      {
        a: "In the shastra the opening sound is the seed: it vibrates with the child's nakshatra pada, and everything after it is elaboration. That is why two very different names sharing an auspicious first syllable are both acceptable, while an elegant name opening on a hostile sound is not.",
        q: "Why do syllables matter more than the full name?",
      },
      {
        a: "Yes — alongside the everyday shortlist it derives the traditional rashi-anchored option many families keep for ceremonies, temple records, and elder blessings, so both customs are honoured without confusion.",
        q: "Can the report help with a rashi name too?",
      },
      {
        a: "Usually, yes. Regional and family conventions — a grandfather's initial, a lineage deity, a caste tradition — typically constrain the choice rather than conflict with it, and the curated shortlist is wide enough to satisfy the elders and the ephemeris at once.",
        q: "Our community follows its own naming customs — can both be respected?",
      },
      {
        a: "The astronomy is identical — nakshatra and pada care nothing for gender — but the curated lists differ, and certain sounds carry gendered conventions in each language. The document presents masculine, feminine, and neutral candidates for the same auspicious opening so every family preference has room.",
        q: "Is there a difference between a boy's and a girl's reading?",
      },
      {
        a: "Sanskrit roots dominate, as the tradition expects, with Hindi, and widely used regional forms represented — each transliterated clearly so grandparents, school forms, and passports all spell the same child the same way.",
        q: "Which languages do the curated names span?",
      },
    ],
    fit: "Best when the naming ceremony is near and you want the nakshatra-correct syllables before choosing, or to check a name you already have in mind. Grandparents' shortlists welcome — the report scores existing candidates as readily as it proposes new ones.",
    lead: "In namkaran, the first syllable is chosen from the child's janma nakshatra and pada, so the name carries the Moon's blessing from birth. A trending name from a list skips this entirely. This report gives the exact syllables the nakshatra opens, then names that fit them. The sound a child answers to thousands of times a year is not decoration in the tradition — it is the Moon's syllable, chosen so the earliest identity aligns with the birth sky. The report does the astronomy first, then the curation, so the shortlist you argue over at home is already auspicious.",
    slug: "baby-name-report",
    title: "Why does naming your child feel heavier than every other decision?",
    intent: "chart_report",
    eyebrow: "Baby Name Report",
    reportSlug: "baby-name",
    checkpoints: [
      "The child's janma nakshatra and pada from birth details",
      "Auspicious starting syllables (namkaran akshar) the nakshatra opens",
      "30+ curated names for those syllables, each with meaning",
      "Numerology fit of each name with the child's birth number",
      "Gender-wise name lists for each auspicious syllable, classical and modern",
      "A cross-check of any shortlisted family name against the chart",
    ],
    description:
      "A personal namkaran report: the child's janma nakshatra and pada, the auspicious starting syllables, and 30+ curated names with meanings and numerology fit.",
    inputSurface: "kundali",
    offerSubhead:
      "Enter the child's birth details first, then get the janma nakshatra, the auspicious starting syllables, and 30+ fitted names with meanings.",
    offerHeadline: "Get your Baby Name Report",
    customerProblem: "baby_name",
    collectInputsLabel: "Enter birth details for Baby Name Report",
  },
  "career-report": {
    faq: [
      {
        a: "It shows the work environments, strengths, timing, and career pressure points your chart supports instead of giving a generic job list.",
        q: "Will it tell me the right profession?",
      },
      {
        a: "Yes. It reads career and finance through the 10th, 11th, dasha, and relevant graha strength.",
        q: "Does it include business guidance?",
      },
    ],
    fit: "Best when promotions, job changes, business timing, or income growth feel delayed despite consistent effort.",
    lead: "Career does not move only because effort increases. Your 10th house, D10, Shani, Jupiter, Sun, Budh, and active dasha decide when work becomes visible and when patience is smarter.",
    slug: "career-report",
    title: "Why does your career keep stalling despite hard work?",
    intent: "chart_report",
    eyebrow: "Career Report",
    reportSlug: "career-report",
    checkpoints: [
      "10th house and D10/Dasamsa career direction",
      "Current dasha and transit support for job or business",
      "Wealth yogas and blocked income patterns",
      "Career upay matched to the graha causing delay",
    ],
    description:
      "A personal Vedic career report for 10th house, D10/Dasamsa, Shani, Jupiter, dasha timing, wealth yogas, and career upay.",
    inputSurface: "kundali",
    offerSubhead:
      "Generate your kundali first, then get the 10th house, D10, dasha timing, wealth yogas, and career upay report matched to your chart.",
    offerHeadline: "Get your Career Report",
    customerProblem: "career",
    collectInputsLabel: "Enter birth details for Career Report",
  },
  "career-astrology-report": {
    faq: [
      {
        a: "It shows the work environments, strengths, and timing your chart supports instead of giving a generic job list.",
        q: "Will it tell me the right profession?",
      },
      {
        a: "Yes. It reads career and finance through the 10th, 11th, dasha, and relevant graha strength.",
        q: "Does it include business guidance?",
      },
    ],
    fit: "Best when promotions, job changes, business timing, or income growth feel delayed despite consistent effort.",
    lead: "Career timing is not only about effort. The 10th house, D10, Shani, Jupiter, Sun, Mercury, and the active dasha decide when work becomes visible and when patience is smarter.",
    slug: "career-astrology-report",
    title: "Why does your hard work not convert into career results at the right time?",
    intent: "chart_report",
    eyebrow: "Career Astrology Report",
    reportSlug: "career-report",
    checkpoints: [
      "10th house and Dasamsa career direction",
      "Current dasha and transit support for job or business",
      "Wealth yogas and blocked income patterns",
      "Career upay matched to the graha causing delay",
    ],
    description:
      "A Vedic career astrology report for 10th house, D10/Dasamsa, Shani, Jupiter, dasha timing, wealth yogas, and career upay.",
    inputSurface: "kundali",
    offerSubhead:
      "Generate your kundali first, then get the 10th house, D10, dasha timing, wealth yogas, and career upay report matched to your chart.",
    offerHeadline: "Get your Career Report",
    customerProblem: "career",
    collectInputsLabel: "Enter birth details for Career Report",
  },
  "dosha-report": {
    faq: [
      {
        a: "Yes. It focuses on the doshas available in the Ishvaram engine and explains which one is actually active for your chart.",
        q: "Will it check multiple doshas?",
      },
      {
        a: "No. The report checks cancellation and severity first, then recommends the lighter or stronger upay your chart actually supports.",
        q: "Will it recommend a strong ritual immediately?",
      },
    ],
    fit: "Best when one or more doshas have been mentioned and you need the safe next step instead of a generic remedy list.",
    lead: "A dosha report should reduce fear, not create it. The right read checks whether a dosha actually fires, whether cancellation applies, which life area is affected, and which upay is safe before any strong remedy is suggested.",
    slug: "dosha-report",
    title: "Why follow a dosha upay before checking your chart?",
    intent: "remedy_dosha",
    eyebrow: "Dosha Report",
    reportSlug: "dosha-remedy-plan",
    checkpoints: [
      "Mangal, Kaal Sarp, Pitra, Shani and other chart pressure checks",
      "Severity and cancellation before remedies",
      "Affected life areas separated clearly",
      "Safe upay routine: mantra, donation, vrata, shanti, or product guidance",
    ],
    description:
      "A chart-specific Dosha Report for Mangal, Kaal Sarp, Pitra, Shani and other pressure checks, with severity, cancellation, and safe upay.",
    inputSurface: "kundali",
    offerSubhead:
      "Generate your kundali first, then get the dosha severity, cancellation checks, active life area, and safe upay sequence matched to your chart.",
    offerHeadline: "Get your Dosha Report",
    customerProblem: "dosha",
    collectInputsLabel: "Enter birth details for Dosha Report",
  },
  "dosha-remedy-plan": {
    faq: [
      {
        a: "Yes. It focuses on the doshas available in the Ishvaram engine and explains which one is actually active for your chart.",
        q: "Will it check multiple doshas?",
      },
      {
        a: "Only where the chart supports a product upay. The report prioritises safe routine and classical remedy order first.",
        q: "Does it recommend products?",
      },
    ],
    fit: "Best when one or more doshas have been mentioned and you need the safe next step instead of a generic remedy list.",
    lead: "A dosha report should reduce fear, not create it. This plan checks whether a dosha actually fires, whether cancellation applies, and which upay is safe before any strong remedy is suggested.",
    slug: "dosha-remedy-plan",
    title: "Why choose an upay before confirming the dosha and cancellation?",
    intent: "remedy_dosha",
    eyebrow: "Dosha Remedy Plan",
    reportSlug: "dosha-remedy-plan",
    checkpoints: [
      "Mangal, Kaal Sarp, Pitra, Shani and other chart pressure checks",
      "Severity and cancellation before remedies",
      "Affected life areas separated clearly",
      "Safe upay routine: mantra, donation, vrata, shanti, or product guidance",
    ],
    description:
      "A chart-specific Dosha Remedy Plan for severity, cancellation, affected life area, safe upay, mantra routine, and matched remedy guidance.",
    inputSurface: "kundali",
    offerSubhead:
      "Generate your kundali first, then get dosha severity, cancellation checks, affected life area, and safe upay guidance.",
    offerHeadline: "Get your Dosha Remedy Plan",
    customerProblem: "dosha",
    collectInputsLabel: "Enter birth details for Dosha Plan",
  },
  "gemstone-report": {
    faq: [
      {
        a: "Rashi-based charts ignore your lagna and dasha, which is why they often strengthen a graha your chart does not want strong. This report reads your functional benefics first, so the stone is matched to your chart.",
        q: "Can't I just wear the stone for my rashi?",
      },
      {
        a: "The report gives a wearable rudraksha equivalent for each ratna, so the same graha has an accessible remedy without a large spend.",
        q: "What if I cannot afford the recommended ratna?",
      },
      {
        a: "Dhaaran vidhi is the prescribed way of first wearing a ratna — the metal, the finger, the weekday and hora, the mantra, and the purification before the stone touches skin. A correct stone worn casually gives weak results; the report gives the full vidhi so the remedy actually engages.",
        q: "What is dhaaran vidhi and why does it matter?",
      },
      {
        a: "Yes — which is exactly why the report exists. A ratna strengthens its graha whether or not that strengthening helps your chart, and the heavier stones for Shani, Rahu, and Ketu work are prescribed sparingly. The report checks your lagna, each planet's functional nature, and the running dasha before recommending anything.",
        q: "Can a gemstone be harmful?",
      },
      {
        a: "Each recommended ratna is paired with the mukhi rudraksha that addresses the same graha, with its own wearing method. Rudraksha is the gentler instrument — it never harms — so it is the default suggestion wherever the chart sits on a borderline.",
        q: "Which rudraksha does the report cover?",
      },
      {
        a: "Classically a stone is given one mandala — roughly forty days of continuous wearing — before judging it, and its effect strengthens through the ruling graha's dasha and antardasha. The report tells you which of your periods the stone is actually working for, so you neither discard it early nor credit it for another planet's work.",
        q: "How long before a ratna shows results?",
      },
      {
        a: "Yes — a ratna is worn as a living remedy, not jewellery. The dhaaran vidhi in the report covers the soaking, the graha mantra recitation, and the first-wearing muhurat, because an unconsecrated stone is considered dormant in the tradition however fine its quality certificate reads.",
        q: "Does the stone need purification and pran pratishtha?",
      },
      {
        a: "A flawed or heavily treated stone is held to transmit poorly — clarity and honest origin matter more than size. The report specifies what to insist on when buying, so a jeweller's upsell cannot substitute for the chart's actual requirement.",
        q: "Does gemstone quality matter as much as choice?",
      },
      {
        a: "Each graha has its preferred carrier metal, and the wrong setting can mute an otherwise correct stone — silver cools where gold heats. The vidhi names the metal, the finger, and the day together as one prescription, not three separate suggestions.",
        q: "Gold, silver, or panchdhatu — does the metal really matter?",
      },
      {
        a: "Only when their grahas are friends. Certain famous pairings are outright contraindicated — enemies on the same hand pull a chart in opposite directions — and the report flags every forbidden combination alongside its recommendations.",
        q: "Can I wear two ratna together?",
      },
      {
        a: "Shukra's opal and Rahu's gomed are precisely the stones most often handed out on hearsay, and the least forgiving when mismatched. Bring any prior advice to the report; it will either confirm the prescription or retire it with reasons you can read.",
        q: "I was told opal and hessonite casually — should I worry?",
      },
    ],
    fit: "Best before you buy a gemstone, or when a stone you already wear feels wrong and you want the lagna-and-dasha reason first. Also worth running for a stone inherited or gifted, where sentiment and astrology may disagree.",
    lead: "A ratna strengthens a graha, so the wrong stone strengthens the wrong planet — which is why a rashi-based gemstone often does nothing or makes things heavier. This report reads your lagna, functional benefics, and active dasha first, then names the stone your chart actually needs. The stakes are asymmetric: a correct ratna quietly amplifies a supportive graha for years, while a fashionable one worn on hearsay can sharpen exactly the affliction you were trying to escape. The report treats a recommendation as a prescription, complete with what to avoid and why.",
    slug: "gemstone-report",
    title: "Why did the gemstone you were told to wear change nothing?",
    intent: "remedy_dosha",
    eyebrow: "Rudraksha & Ratna Report",
    reportSlug: "gemstone-recommendation",
    checkpoints: [
      "The ratna your chart needs, ranked by lagna lord and active dasha",
      "Stones to avoid — the grahas your chart does not want strengthened",
      "The wearable rudraksha (mukhi) equivalent when a ratna is not suitable",
      "Full dhaaran vidhi: metal, finger, weight, day, and graha mantra",
      "Substitute (uparatna) options when the primary stone is beyond budget",
      "The dasha timing — when to begin wearing and when a stone should rest",
    ],
    description:
      "A personal ratna and rudraksha report: which stone your chart needs by lagna and dasha, the wearable rudraksha equivalent, and the full dhaaran vidhi.",
    inputSurface: "kundali",
    offerSubhead:
      "Generate your kundali first, then get the ratna ranked to your lagna and dasha, the rudraksha equivalent, and the dhaaran vidhi to activate it.",
    offerHeadline: "Get your Rudraksha & Ratna Report",
    customerProblem: "gemstone",
    collectInputsLabel: "Enter birth details for Ratna Report",
  },
  "lal-kitab-report": {
    faq: [
      {
        a: "Lal Kitab uses its own house system and reads the chart as ancestral debts (rin) and blind or sleeping planets, pointing at low-cost totke rather than gemstones or long pujas.",
        q: "How is Lal Kitab different from my normal kundali reading?",
      },
      {
        a: "No. Lal Kitab totke are deliberately simple and low-cost. The report gives only the ones matched to your active rin, in the right order.",
        q: "Are the totke complicated or expensive?",
      },
      {
        a: "In Lal Kitab a planet can sit in a house where it gives no result — asleep — or act without seeing what it affects — blind. Its periods then feel strangely empty or misdirected: effort goes in, nothing comes back. The report marks which of your planets carry these states and the totka that wakes each one safely.",
        q: "What is a blind or sleeping planet?",
      },
      {
        a: "Rin is Lal Kitab's ledger reading: inherited patterns — pitru rin, matru rin, and their siblings — that repeat as the same money, family, or health trouble across generations. Each active debt has its own settlement, usually quiet service or giving rather than expensive ritual, and the report matches the settlement to the debt actually shown in your chart.",
        q: "What exactly is rin, the ancestral debt?",
      },
      {
        a: "A Lal Kitab chart is built from your birth details like a normal kundali, so date, time, and place give the cleanest reading. Where a doubtful time would change a house placement, the report says so plainly instead of pretending certainty.",
        q: "Do I need my exact birth time for Lal Kitab?",
      },
      {
        a: "Because a totka acts on a planet, and a planet serving you well must not be disturbed. Lal Kitab is unusually strict about this: the wrong remedy is treated as worse than none. The report therefore lists what to avoid alongside what to do — both halves come from the same debt reading.",
        q: "Why does Lal Kitab forbid some remedies for me?",
      },
      {
        a: "No — same planets, different diagnostic lens. Parashari Jyotish reads strength, aspects, and periods; Lal Kitab reads occupation of houses as debts and duties. Where the two agree the signal is loud; where they diverge, the report says which lens fits your situation and why.",
        q: "Is Lal Kitab opposed to regular Jyotish?",
      },
      {
        a: "Lal Kitab asks for consistency over intensity — a remedy done in its prescribed sequence, usually across consecutive weeks, matters more than any single grand gesture. Expect gradual easing of the pressed life area rather than an overnight reversal; the tradition itself warns against dramatic promises.",
        q: "How soon does a totka show its effect?",
      },
      {
        a: "From the early twentieth-century Urdu volumes compiled in Punjab, which built a self-contained system of houses, debts, and remedies that spread across North India on results rather than lineage. The report stays inside that codified core and avoids the folklore that later attached itself to the name.",
        q: "Where does Lal Kitab's authority come from?",
      },
      {
        a: "Some classical settlements involve feeding dogs, crows, or cows, floating grain, or burying an article — always inexpensive, always ordinary. Where a household cannot perform one, the report offers the accepted alternative rather than leaving a debt unaddressed.",
        q: "Will the report ask me to keep animals or bury things?",
      },
    ],
    fit: "Best when a money or family pattern keeps repeating and you want low-cost, home-doable remedies matched to the actual debt, not generic totke. A practical fit for households that want remedies measured in effort and sincerity, not spend.",
    lead: "Lal Kitab reads your chart as a ledger of rin — ancestral debts — and blind or sleeping planets giving no result. A totka from folklore only helps if it matches the debt being collected. This report names which rin is active in your chart and the totke that clear it. Its power is practicality: instead of prescribing costly stones or long pujas, Lal Kitab settles a debt with feeding, giving, burying, or floating simple articles — acts a household can actually perform — provided they match the debt, the planet, and the prescribed sequence.",
    slug: "lal-kitab-report",
    title: "Why does the same money or family trouble keep circling back?",
    intent: "remedy_dosha",
    eyebrow: "Lal Kitab Remedy Report",
    reportSlug: "lal-kitab",
    checkpoints: [
      "Your Lal Kitab chart in its own house-and-debt system",
      "Active ancestral debts (rin) and the life area each one presses on",
      "Blind and sleeping planets that need waking correctly",
      "Simple, low-cost totke matched to your chart, in prescribed order",
      "Varshphal-style year reading in the Lal Kitab tradition",
      "What to stop doing — the everyday habits that feed an active debt",
    ],
    description:
      "A personal Lal Kitab report: your Lal Kitab chart, the active ancestral debts (rin), blind and sleeping planets, and the simple low-cost totke matched to your chart.",
    inputSurface: "kundali",
    offerSubhead:
      "Generate your kundali first, then get your Lal Kitab chart, the active rin, the blind planets, and the simple totke matched to your chart.",
    offerHeadline: "Get your Lal Kitab Remedy Report",
    customerProblem: "lal_kitab",
    collectInputsLabel: "Enter birth details for Lal Kitab Report",
  },
  "mahadasha-forecast": {
    faq: [
      {
        a: "No. Varshphal reads the year chart. This report reads your active dasha period and the next 12 months of sub-period movement.",
        q: "Is this the same as Varshphal?",
      },
      {
        a: "Use the most accurate time available. The dasha comes from Moon nakshatra, while exact birth time improves the house context.",
        q: "Can I use it without exact birth time?",
      },
    ],
    fit: "Best when you are deciding whether to act, wait, change job, start something, or understand why a phase has shifted.",
    lead: "Mahadasha is the background climate of your life. The same effort can feel blocked or supported depending on the active graha and sub-period. This report turns that timing into practical next steps.",
    slug: "mahadasha-forecast",
    title: "Which mahadasha is setting the timing behind your next 12 months?",
    intent: "chart_report",
    eyebrow: "Mahadasha Forecast",
    reportSlug: "mahadasha-forecast",
    checkpoints: [
      "Current mahadasha and antardasha from Moon nakshatra",
      "Next transition points and month-level timing",
      "Career, money, marriage, family, health, and spiritual focus",
      "Graha-specific upay for the active period",
    ],
    description:
      "A 12-month Mahadasha Forecast with current mahadasha, antardasha, transition timing, decision windows, and graha-specific upay.",
    inputSurface: "kundali",
    offerSubhead:
      "Generate your kundali first, then get current mahadasha, antardasha, transition timing, decision windows, and graha-specific upay.",
    offerHeadline: "Get your Mahadasha Forecast",
    customerProblem: "mahadasha",
    collectInputsLabel: "Enter birth details for Mahadasha Forecast",
  },
  "marriage-report": {
    faq: [
      {
        a: "The paid Marriage Report is based on two charts. Without both birth details, Gun Milan, Mangal Dosh cross-check, D9/Navamsha, and dasha synchrony would be incomplete.",
        q: "Why do you need both birth details?",
      },
      {
        a: "Yes. The score is only the first layer. The report explains the weak areas, cancellations, dasha timing, relationship risks, and upay families can actually discuss.",
        q: "Is this more than a Gun Milan score?",
      },
    ],
    fit: "Best before families decide, when the match looks good but one chart point or repeated doubt needs a proper Vedic cross-check.",
    lead: "Marriage matching should not stop at a score. The 7th house, Mangal placement, Nadi/Bhakoot, D9/Navamsha, and both partners' dasha timing decide whether the match is stable, delayed, or needs upay.",
    slug: "marriage-report",
    title: "Why does the same relationship doubt return before marriage?",
    intent: "chart_report",
    eyebrow: "Marriage Report",
    reportSlug: "marriage-report",
    checkpoints: [
      "Full 36-point Gun Milan with the weak kootas explained",
      "Mangal Dosh, Nadi, Bhakoot, Gana, and cancellation checks",
      "D9/Navamsha and dasha timing for marriage stability",
      "Clear strengths, risks, remedies, and family-shareable summary",
    ],
    description:
      "A family-shareable Marriage Report for Kundali Milan, 7th house, Mangal Dosh, D9/Navamsha, dasha timing, and practical upay.",
    inputSurface: "matching",
    offerSubhead:
      "Enter both birth details first. The report uses the actual Kundali Milan result, Mangal Dosh, D9/Navamsha, and dasha timing before checkout.",
    offerHeadline: "Get your Marriage Report",
    customerProblem: "marriage",
    collectInputsLabel: "Enter both birth details",
  },
  "muhurat-report": {
    faq: [
      {
        a: "It uses the public timing layer but adds your purpose, city, birth chart, avoid windows, and sankalp.",
        q: "Is this better than a choghadiya calculator?",
      },
      {
        a: "Use it for initial timing guidance. A final wedding muhurat still benefits from family constraints and pandit confirmation.",
        q: "Can it replace a wedding muhurat?",
      },
    ],
    fit: "Best before launches, purchases, griha pravesh, travel, naming, rituals, or family decisions where timing matters.",
    lead: "A public choghadiya slot is only the outer layer. A cleaner muhurat checks city panchang, purpose, Moon sign, dasha pressure, avoid windows, and the sankalp you should take before starting.",
    slug: "muhurat-report",
    title: "Why does a shubh time need your city, purpose, and kundali together?",
    intent: "timing_muhurat",
    eyebrow: "Personal Muhurat Report",
    reportSlug: "muhurat-report",
    checkpoints: [
      "Purpose-specific timing instead of a generic table",
      "Tithi, nakshatra, yoga, karana, weekday, and choghadiya",
      "Rahu Kaal, Yamagandam, Gulika Kaal, and personal dasha pressure",
      "Sankalp wording and practical ritual checklist",
    ],
    description:
      "A personal Muhurat report for purpose-specific timing, avoid windows, panchang, sankalp, and ritual checklist.",
    inputSurface: "kundali",
    offerSubhead:
      "Generate your kundali first, then get purpose-specific timing, avoid windows, panchang, sankalp, and ritual checklist.",
    offerHeadline: "Get your Muhurat Report",
    customerProblem: "muhurat",
    collectInputsLabel: "Enter details for Muhurat Report",
  },
  "numerology-report": {
    faq: [
      {
        a: "Lucky numbers are one part. The report reads the graha each of your numbers rules, checks whether your name-number supports your birth number, and gives the upay for the pattern your chart carries.",
        q: "Is this only about lucky numbers?",
      },
      {
        a: "Numerology runs from your date of birth and name, so those are enough for the core report. Birth time only sharpens the kundali cross-read of your ruling grahas.",
        q: "Do I need my birth time?",
      },
      {
        a: "Your mulank — the root number from your day of birth — describes your instinctive nature. Your bhagyank, drawn from the full date, shows the direction life keeps bending toward regardless of plans. When the two disagree, a person feels permanently pulled in two directions; the report names that friction and the graha behind it.",
        q: "What are mulank and bhagyank?",
      },
      {
        a: "In Ank Jyotish the name you use daily carries its own number. When it fights your birth numbers, the friction is subtle but constant — like walking with a stone in the shoe. The report checks the harmony first and suggests an adjustment only when the mismatch is real; a name is never changed for fashion.",
        q: "Can changing my name spelling really matter?",
      },
      {
        a: "Your personal year cycles with each birthday, colouring the twelve months that follow — one year favours beginnings, another consolidation, another clearing old debts. The report tells you which year you are standing in and what that cycle rewards, so effort lands where the number supports it.",
        q: "How does the year-ahead reading work?",
      },
      {
        a: "It stands on its own — the numbers and the grahas ruling them carry the core reading. But because each number answers to a planet, cross-reading the kundali shows whether that planet is strong or afflicted in your chart, which decides how loudly the number speaks. The report does both when birth time is available.",
        q: "Does numerology work without a kundali?",
      },
      {
        a: "The classical Vedic assignment: one belongs to Surya, two to Chandra, three to Guru, four to Rahu, five to Budh, six to Shukra, seven to Ketu, eight to Shani, and nine to Mangal. Every reading in the report traces back to this mapping, so the numerology and the kundali speak the same planetary language.",
        q: "Which number-to-graha mapping does the report use?",
      },
      {
        a: "Yes — mulank pairs have well-known harmonies and frictions, which is why partners and business associates often check them before formalising anything. The report reads your own numbers; for a full two-chart compatibility, the kundali matching tools on this site do the deeper Ashtakoota work.",
        q: "Can two people compare their numbers?",
      },
      {
        a: "Western schools celebrate eleven and twenty-two; Ank Jyotish quietly reduces them and reads the ruling graha instead, because the planet — not the glamour of a repeated digit — is what acts in a life. The report follows the Vedic treatment and explains the difference wherever your dates touch it.",
        q: "My date adds up to a master number — is that special?",
      },
      {
        a: "Treat it as one instrument in the orchestra. For marriage, property, or a major venture, pair it with the kundali and an honest muhurat — the numbers sharpen the picture, the chart settles it.",
        q: "Is a numerology report enough on its own for big decisions?",
      },
      {
        a: "As a written document you keep — tables for the quick glances, plain explanation underneath, and the upay steps separated so nothing important hides inside a paragraph you skim.",
        q: "How is the report delivered?",
      },
      {
        a: "Residences carry a number like everything else, and a dwelling that quarrels with its occupants' ruling digits is a classic source of low-grade unease. The report shows how to reduce an address and judge the fit before a move or purchase.",
        q: "Does the house or flat number I live in matter?",
      },
    ],
    fit: "Best when the same money, career, or relationship pattern keeps repeating and you want the number-and-graha reason before a naming or business decision. Equally suited to checking a brand, firm, or house number before committing to it.",
    lead: "Your mulank and bhagyank are not lucky-charm trivia — they are ruled by the same grahas sitting in your kundali. When your name-number fights your birth number, the friction shows up as repeated delay. This report names the graha behind each number and the upay that settles it. Ank Jyotish is the bridge discipline: every number answers to a graha, so a weak number in your dates often mirrors an afflicted planet in the kundali. Reading both layers together separates a cosmetic fix from a real correction — and tells you whether the remedy belongs to the name, the number, or the planet itself.",
    slug: "numerology-report",
    title: "Why do your numbers keep pulling you toward the same delays?",
    intent: "chart_report",
    eyebrow: "Numerology Life Report",
    reportSlug: "numerology-life",
    checkpoints: [
      "Mulank and bhagyank with the graha each one rules",
      "Name-number harmony — where your name works with your birth number and where it fights it",
      "Lucky numbers, days, and directions matched to your ruling grahas",
      "Year-ahead numerology cycle and numerology upay",
      "Personal year cycle — which of the nine years you are standing in and what it rewards",
      "Business and vehicle number compatibility with your ruling numbers",
    ],
    description:
      "A personal Ank Jyotish report for your mulank and bhagyank, the graha each rules, name-number harmony, lucky numbers and days, and the year ahead.",
    inputSurface: "kundali",
    offerSubhead:
      "Generate your kundali first, then get your mulank, bhagyank, name-number harmony, lucky numbers, and the year-ahead cycle read against your grahas.",
    offerHeadline: "Get your Numerology Life Report",
    customerProblem: "numerology",
    collectInputsLabel: "Enter birth details for Numerology Report",
  },
  "pitra-dosh-report": {
    faq: [
      {
        a: "Yes. The calculator gives the quick signal. The report explains severity, cancellation, activation, affected life areas, and the upay sequence.",
        q: "Is this different from the Pitra Dosh calculator?",
      },
      {
        a: "Only if the chart supports a stronger upay. Mild or cancelled patterns are handled with lighter, safer upay.",
        q: "Will it recommend an expensive ritual?",
      },
    ],
    fit: "Best when recurring family or career blocks are being explained as ancestral karma and you want the chart verified first.",
    lead: "Pitra Dosh is serious enough that it should be confirmed before any tarpan, shradh, donation, or puja sequence is started. The report checks the rule, severity, cancellation, and activation window first.",
    slug: "pitra-dosh-report",
    title: "Is Pitra Dosh really present, or is your chart showing a different family pattern?",
    intent: "remedy_dosha",
    eyebrow: "Pitra Dosh Report",
    reportSlug: "pitra-dosh",
    checkpoints: [
      "Sun, 9th house, 9th lord, Rahu/Ketu and Saturn checks",
      "Cancellation factors before severity is finalised",
      "Family, father-line, career, and money pattern interpretation",
      "Tarpan, shradh, mantra, donation, or lighter upay sequence",
    ],
    description:
      "A personal Pitra Dosh report for Sun, 9th house, Rahu/Ketu, cancellation checks, dasha activation, and safe ancestral upay.",
    inputSurface: "kundali",
    offerSubhead:
      "Generate your kundali first, then get Sun, 9th house, Rahu/Ketu, cancellation checks, dasha activation, and safe ancestral upay.",
    offerHeadline: "Get your Pitra Dosh Report",
    customerProblem: "pitra_dosh",
    collectInputsLabel: "Enter birth details for Pitra Dosh Report",
  },
  "sade-sati-report": {
    faq: [
      {
        a: "It gives the phase context from your Moon sign and connects it with your kundali. Exact timing is computed after you submit birth details.",
        q: "Will this tell me exact Sade Sati dates?",
      },
      {
        a: "No. It can also help if Sade Sati recently ended or is approaching, because the report reads Shani's natal promise and dasha context.",
        q: "Is it only for people currently in Sade Sati?",
      },
    ],
    fit: "Best when you already know or suspect Sade Sati and want a chart-level answer before doing heavy Shani remedies.",
    lead: "Sade Sati should not be read from Moon sign alone. Your natal Shani, active dasha, and house pressure decide whether this phase feels like delay, discipline, family pressure, career restructuring, or inner heaviness.",
    slug: "sade-sati-report",
    title: "Is Shani testing your Moon sign, or is another dasha creating the pressure?",
    intent: "remedy_dosha",
    eyebrow: "Sade Sati Report",
    reportSlug: "sade-sati",
    checkpoints: [
      "Current Sade Sati phase from your Moon sign",
      "Natal Shani placement and strength",
      "Dasha context so Shani is not blamed for everything",
      "Simple Shani upay matched to your chart",
    ],
    description:
      "A personal Sade Sati report for Shani phase, natal Saturn, dasha context, pressure areas, and chart-specific upay.",
    inputSurface: "kundali",
    offerSubhead:
      "Generate your kundali first, then get Shani phase, natal Saturn, dasha context, pressure areas, and chart-specific upay.",
    offerHeadline: "Get your Sade Sati Report",
    customerProblem: "sade_sati",
    collectInputsLabel: "Enter birth details for Sade Sati Report",
  },
  "gochar-report": {
    faq: [
      {
        a: "A monthly horoscope is written for a whole rashi. This forecast reads Saturn and Jupiter moving through your own houses from your Moon sign, with exact ingress dates and the 12-month windows that matter for your chart.",
        q: "How is this different from a monthly horoscope?",
      },
      {
        a: "Sade Sati is Shani's phase over your Moon sign specifically. The gochar forecast is broader — both Shani and Guru transits across all your houses. If Sade Sati is your main concern, the Sade Sati report goes deeper on that one phase.",
        q: "Is this the same as a Sade Sati report?",
      },
      {
        a: "They do different work. Shani moving over a house slows it, tests its foundations, and rewards only disciplined effort; Guru's passage expands the same territory — support arrives, doors open, growth compounds. The forecast weighs both together, because a Guru opening during a heavy Shani stretch plays out very differently from one on a clear field.",
        q: "Which transit matters more — Shani's or Guru's?",
      },
      {
        a: "An ingress is the day a planet leaves one rashi and enters the next, shifting its influence to a new house of your chart. Around that boundary the theme of the pressure changes — money worries fade and family matters rise, or a stalled promotion suddenly moves. Knowing the boundary in advance is what makes timing possible.",
        q: "What does an ingress date actually change?",
      },
      {
        a: "The transit itself cannot be cancelled, but its expression can be steadied. Where the map shows a harsh stretch, the forecast pairs it with the classical upay for that graha — daan, mantra, the fasting day, and the conduct the shastras prescribe — so you pass through the period with less damage.",
        q: "Can a difficult transit be remedied?",
      },
      {
        a: "Yes — the dasha is the soil, the transit is the season. A Guru transit delivers its promise generously inside a favourable mahadasha and only modestly inside a hostile one, which is why two people with the same Moon sign live the same transit differently. The forecast reads your transits through your running dasha, not in isolation.",
        q: "Does my dasha change what a transit means?",
      },
      {
        a: "Surya, Budh, and Shukra cross a rashi in weeks, giving the month its texture but rarely changing a life's direction. Shani and Guru are the slow movers whose stay in a house lasts long enough to build or dismantle something real — which is why the forecast is built around them, with retrograde re-crossings dated separately.",
        q: "Do the faster planets matter too?",
      },
      {
        a: "Once a year is the natural rhythm — the way families once sat with a fresh panchang — or whenever a major ingress falls in your chart. Since Shani stays in one rashi for roughly two and a half years and Guru for about one, most of the map holds steady between refreshes.",
        q: "How often should I refresh the forecast?",
      },
      {
        a: "Transits are counted from the Moon sign, the classical seat of experienced results, while the lagna supplies context on health and self. The forecast anchors on the Moon and annotates where the lagna view materially disagrees.",
        q: "Is the forecast written for my Moon sign or my lagna?",
      },
    ],
    fit: "Best before a career move, purchase, or major commitment when you want to time it to Saturn and Jupiter's next ingress instead of fighting the transit. Also useful annually, the way families once sat with a panchang at new year — one reading that frames the twelve months ahead.",
    lead: "The climate around you is set by gochar — the live transits of Shani and Guru over your chart. Effort feels blocked or supported depending on where they are moving through your houses. This report maps those transits and the months the pressure and the openings actually arrive. Unlike a generic yearly prediction, the map is drawn planet by planet: each ingress, each retrograde pass, each station is dated, and the affected house named — so instead of a vague 'good phase after summer' you hold a calendar of when to push a negotiation, sign, invest, or simply wait.",
    slug: "gochar-report",
    title: "Why does one year lift everything and the next feel uphill?",
    intent: "chart_report",
    eyebrow: "Gochar Transit Forecast",
    reportSlug: "gochar-transit",
    checkpoints: [
      "Shani and Guru gochar over your chart from your Moon sign",
      "Key ingress dates when each planet changes rashi",
      "The houses each transit activates and the life area it touches",
      "A 12-month timing map: the windows to act and the windows to hold",
      "Retrograde passes — when a planet re-crosses the same degree and reopens a theme",
      "How the current mahadasha colours what each transit can deliver",
    ],
    description:
      "A personal gochar report: Shani and Guru transits over your chart, the key ingress dates, the houses each transit activates, and a 12-month timing map.",
    inputSurface: "kundali",
    offerSubhead:
      "Generate your kundali first, then get Shani and Guru transits over your houses, the ingress dates, and the 12-month act-and-hold timing map.",
    offerHeadline: "Get your Gochar Transit Forecast",
    customerProblem: "gochar",
    collectInputsLabel: "Enter birth details for Gochar Forecast",
  },
} as const;
export type ReportIntentPageSlug = keyof typeof reportIntentPages;
